import Login from 'containers/Login';
import LoginAlternateApp from 'containers/LoginAlternateApp';
import LoginByToken from 'containers/Login/LoginByToken';
import SignUp from 'containers/SignUp';
import SignUpActivation from 'containers/SignUpActivation';
import ForgotPassword from 'containers/ForgotPassword';
import RecoverPassword from 'containers/RecoverPassword';

export default [
  {
    component: Login,
    path: '/login',
    layout: '/auth',
  },
  {
    component: LoginAlternateApp,
    path: '/select-app',
    layout: '/auth',
  },
  {
    component: LoginByToken,
    path: '/bytoken/:token',
    layout: '/auth',
  },
  {
    component: RecoverPassword,
    path: '/recover-password/:token',
    layout: '/auth',
  },
  {
    component: ForgotPassword,
    path: '/forgot-password',
    layout: '/auth',
  },
  {
    component: SignUpActivation,
    path: '/sign-up/:token',
    layout: '/auth',
  },
  {
    component: SignUp,
    path: '/sign-up',
    layout: '/auth',
  },
  // {
  //   component: SignUp,
  //   path: '/register/:lang',
  //   layout: '/auth',
  // },
];
